// -- Abenity Core
import domReady from 'abenity-core-js/lib/dom-ready.js';

// -- NPM
import hljs from 'highlight.js/lib/core';
import bash from 'highlight.js/lib/languages/bash';
import 'highlight.js/styles/github.css';

hljs.registerLanguage('bash', bash);

const init = () => {
    document.querySelectorAll('.hljs').forEach((el) => {
        hljs.highlightElement(el);
    });
};

domReady().then(init);
